import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ClientQueryDocumentService {
    constructor(_httpClient) {
        this._httpClient = _httpClient;
        this.baseUrl = `/ClientQueryDocuments`;
        // Nothing to do here.
    }
    downloadTempFile(clientQueryId, documentId) {
        const url = `${this.baseUrl}/DownloadTempFile?clientQueryId=${clientQueryId}&documentId=${documentId}`;
        return this._httpClient
            .get(url, { responseType: 'blob', observe: 'response' })
            .pipe(map((result) => {
            console.log('Object: ', result);
            const blob = new Blob([result.body], { type: result.body.type });
            return blob;
        }));
    }
    uploadDocuments(clientQueryId, fileList, trusteeView) {
        const url = `${this.baseUrl}/uploadDocuments?clientQueryId=${clientQueryId}&trusteeView=${trusteeView}`;
        const files = Array.from(fileList);
        const formData = new FormData();
        for (const file of files) {
            formData.append(`formFiles`, file);
        }
        return this._httpClient
            .post(url, formData).pipe(map((result) => {
            return result;
        }));
    }
    uploadBoxDocuments(clientQueryId, files) {
        const url = `${this.baseUrl}/uploadBoxDocuments?clientQueryId=${clientQueryId}`;
        return this._httpClient
            .post(url, files).pipe(map((result) => {
            return result;
        }));
    }
    updateDocument(item) {
        const url = `${this.baseUrl}/${item.id}`;
        return this._httpClient.put(url, item).pipe(map((result) => {
            return result;
        }));
    }
    deleteDocument(item) {
        const url = `${this.baseUrl}/${item.id}`;
        return this._httpClient.delete(url).pipe(map((result) => {
            return result;
        }));
    }
    getBoxAccessToken() {
        const url = `${this.baseUrl}/getBoxAccessToken`;
        return this._httpClient.get(url).pipe(map((result) => {
            console.log(`getBoxAccessToken`, result);
            return result;
        }));
    }
}
ClientQueryDocumentService.ɵfac = function ClientQueryDocumentService_Factory(t) { return new (t || ClientQueryDocumentService)(i0.ɵɵinject(i1.HttpClient)); };
ClientQueryDocumentService.ɵprov = i0.ɵɵdefineInjectable({ token: ClientQueryDocumentService, factory: ClientQueryDocumentService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ClientQueryDocumentService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();
//# sourceMappingURL=client-query-document.service.js.map